import React from 'react';

const DashboardHome = () => {
    return (
        <div>
            <h1>Home</h1>
        </div>
    );
};

export default DashboardHome;